import React from "react";
import {FormattedMessage} from "react-intl";

const LookingFor = ({content}) => {

  if (content.fieldLookingFor || content.fieldLfBookingTerritory || content.fieldLfManagementTerritory) {
    return (
      <div className="looking-for">
         <span className="label body-m">
            <FormattedMessage id="lookingfor" />:
         </span>
        {content.fieldLfBookingTerritory &&
          <div className="booking">
            <span className="what body-m">
               <FormattedMessage id="booking" />:
             </span>
            {content.fieldLfBookingTerritory &&
              <span className="where body-m">
                {content.fieldLfBookingTerritory}
              </span>
            }
          </div>
        }
        {content.fieldLfLabelTerritory &&
          <div className="music-label">
            <span className="what body-m">
               <FormattedMessage id="label" />:
             </span>
            {content.fieldLfLabelTerritory &&
              <span className="where body-m">
                {content.fieldLfLabelTerritory}
              </span>
            }
          </div>
        }
        {content.fieldLfManagementTerritory &&
          <div className="management">
            <span className="what body-m">
               <FormattedMessage id="management" />:
             </span>
            {content.fieldLfManagementTerritory &&
              <span className="where body-m">
                {content.fieldLfManagementTerritory}
              </span>
            }
          </div>
        }
        {content.fieldLfFreeLabel && content.fieldLfFreeTerritory &&
          <div className="main">
            <span className="what body-m">
               {content.fieldLfFreeLabel}:
             </span>
            {content.fieldLfFreeTerritory &&
              <span className="where body-m">
                {content.fieldLfFreeTerritory}
              </span>
            }
          </div>
        }
      </div>
    );
  } else {
    return false;
  }
};

export default LookingFor;
